<script lang="ts">
    import {pipe} from 'core/utils';
    import {inline, prop} from 'shared/utils/pipes';
    import type {LoanRequestOption, CapabilityOnBuildings} from 'typings/portaro.be.types';

    export let option: LoanRequestOption<CapabilityOnBuildings>;
</script>

<div class="loan-request-option-buildings-list">
    <strong>{pipe(option.capability.buildings, prop('text'), inline(', '))}</strong>
</div>